<template>
  <div class="common-container">
    <div class="qrcode">
      <div class="title">二维码生成器</div>
      <div class="content">
        <div class="qc-left">
          <div class="classify">
            <div class="classify-item" :class="currentClassify == v.key?'act':''" v-for="(v,i) in classifyList"
                 :key="i" @click="classifyFun(v)">
              <span>{{ v.name }}</span>
              <div class="line"></div>
            </div>
          </div>
          <div class="input-wrapper">
            <span v-if="!qrcodeToken">请先登录</span>
            <div v-else class="iw-content">
              <label for="inp-url" v-if="[1,3].indexOf(currentClassify) !== -1">
                <el-input resize="none" id="inp-url" autosize :type="currentClassify==1?'textarea':'text'"
                        v-model="qrcodeContent"
                        :placeholder="`请输入${currentClassify==1?'文本':(currentClassify==3?'网址，比如 http://www.jiancerenzheng.com':'')}`"/>
              </label>

              <div v-else class="upload-content">
                <upload-file :value.sync="qrcodeContent"/>
              </div>
            </div>
          </div>
          <el-button type="primary" v-if="!qrcodeToken" @click="showWechatQrcode = true">扫码登录</el-button>
          <el-button type="primary" v-else :loading="loading" @click="createQrcode">
            {{ loading ? '生成中...' : '生成二维码' }}
          </el-button>
        </div>
        <div class="qc-right">
          <div class="qcr-code">
            <span v-if="!qrcodeImage">此处预览二维码</span>
            <el-image :src="qrcodeImage"></el-image>
          </div>
          <el-button type="primary" @click="downQrcode(qrcodeImage)">下载二维码</el-button>
        </div>
      </div>
    </div>
    <div class="history" v-if="historyList.length > 0">
      <div class="h-content">
        <div class="hc-title">最新生成的二维码</div>
        <div class="hc-list">
          <div class="list-item" v-for="(v,i) in historyList" :key="i">
            <el-image :src="v.image"></el-image>
            <div class="info">
              <div class="content">
                <span v-if="[1,3].indexOf(v.classifyId) !== -1">{{ v.content }}</span>
                <div v-else class="c-icon-name">
                  <el-image :src="require('@/assets/qrcode/icon.png')"></el-image>
                  <span>{{ v.content.substring(v.content.lastIndexOf('/') + 1) }}</span>
                </div>
              </div>
              <div class="time-btn">
                <div class="time">{{ v.createTime }}</div>
                <div class="btn-group">
                  <el-button size="mini" type="primary" @click="delQrcode(v)">删除</el-button>
                  <el-button size="mini" type="primary" @click="downQrcode(v.image)">下载二维码</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    微信授权二维码弹窗-->
    <wechat-qrcode-layer :visible.sync="showWechatQrcode"/>
  </div>
</template>

<script>
import WechatQrcodeLayer from "./components/WechatQrcodeLayer.vue";
import {getQrcodeToken} from "@/utils/qrcode-token";

export default {
  name: "Qrcode",
  components: {
    WechatQrcodeLayer
  },
  data() {
    return {
      classifyList: [
        {
          name: '文本',
          key: 1
        },
        {
          name: '文件',
          key: 2
        },
        {
          name: '网址',
          key: 3
        }
      ],
      currentClassify: 1,
      loading: false,
      historyList: [],
      showWechatQrcode: false,
      qrcodeContent: '',
      qrcodeImage: ''
    }
  },
  computed: {
    qrcodeToken() {
      return getQrcodeToken()
    }
  },
  watch: {
    qrcodeToken: {
      immediate: true,
      handler: function (val) {
        if (val) {
          this.getNewestHistory()
        }
      }
    }
  },
  methods: {
    /**
     * 删除
     * @param qrcodeId
     */
    delQrcode({qrcodeId}) {
      const that = this
      that.$confirm('您确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.$request.post('/Qrcode/delQrcode', {
          openId: this.qrcodeToken,
          qrcodeId
        }).then(res => {
          if (res.code === 0) {
            that.$message.success(res.message)
            that.getNewestHistory()
          }
        })
      })
    },
    /**
     * 下载二维码
     * @param image
     */
    downQrcode(image) {
      if (!image) {
        this.$message.error('暂无二维码下载')
        return false
      }
      window.open(image, '_blank')
    },
    /**
     * 获取最新记录
     */
    getNewestHistory() {
      this.$request('/Qrcode/newestHistory', {
        params: {
          openId: this.qrcodeToken
        }
      }).then(res => {
        if (res.code === 0) {
          this.historyList = res.data
        }
      })
    },
    /**
     * 生成二维码
     */
    createQrcode() {
      if (!this.qrcodeContent) {
        this.$message.error(['请输入文本', '请上传文件', '请输入网址'][this.currentClassify - 1])
        return false
      }
      this.qrcodeImage = ''
      this.loading = true
      this.$request.post('/Qrcode/createQrcode', {
        classifyId: this.currentClassify,
        content: this.qrcodeContent,
        openId: this.qrcodeToken
      }).then(res => {
        if (res.code === 0) {
          this.loading = false
          this.qrcodeImage = res.data.image
          this.getNewestHistory()
        }
      }).catch(e => {
        this.loading = false
      })
    },
    /**
     * 分类选择
     * @param key
     */
    classifyFun({key}) {
      this.currentClassify = key
      this.qrcodeContent = ''
      this.qrcodeImage = ''
    }
  }
}
</script>

<style scoped lang="scss">
.qrcode {
  width: 1200px;
  padding: 30px 0 60px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    color: #2D2D2D;
    font-size: 38px;
    font-weight: bold;
    margin-bottom: 30px;
  }

  .content {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;

    .qc-left {
      width: 856px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .classify {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;

        .classify-item {
          width: 80px;
          text-align: center;
          color: #6C6C6C;
          font-size: 16px;
          font-weight: bold;
          cursor: pointer;

          .line {
            width: 100%;
            height: 4px;
            background-color: #1464FF;
            border-radius: 8px;
            margin-top: 2px;
            opacity: 0;
          }

          &.act {
            color: #2D2D2D;

            .line {
              opacity: 1;
            }
          }
        }
      }

      .input-wrapper {
        width: 100%;
        background-color: #FFFFFF;
        height: 304px;
        border-radius: 4px;
        margin-top: 10px;
        border: 1px solid #D7D7D7;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        span {
          display: block;
          text-align: center;
          line-height: 304px;
          font-size: 18px;
          color: #A4A4A4;
        }

        .iw-content {
          width: 100%;
          height: 100%;

          label {
            display: block;
            height: 100%;
          }

          .upload-content {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
          }

          ::v-deep {
            .el-textarea__inner {
              padding: 10px 15px;
            }

            .el-textarea__inner, .el-input__inner {
              border: 0;
              font-size: 16px;
              font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
            }
            .el-input__inner {
              height: 44px;
              line-height: 44px;
            }

            .el-upload-dragger {
              border: none;
            }

            .el-upload-list__item {
              font-size: 16px;
            }

            .el-textarea, textarea {
              height: 100% !important;
            }
          }
        }
      }
    }

    .qc-right {
      width: 304px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .qcr-code {
        width: 100%;
        height: 304px;
        background-color: #FFFFFF;
        overflow: hidden;
        border-radius: 4px;
        border: 1px solid #D7D7D7;

        span {
          display: block;
          text-align: center;
          line-height: 304px;
          font-size: 18px;
          color: #A4A4A4;
        }

        .el-image {
          width: 100%;
          height: 100%;
        }
      }
    }

    .el-button {
      width: 166px;
      background-color: #1464FF;
      margin-top: 25px;
    }
  }
}

.history {
  width: 100%;
  background-color: #FFFFFF;
  padding: 25px 0 50px 0;
  display: flex;
  flex-direction: row;
  justify-content: center;

  .h-content {
    width: 1200px;
    display: flex;
    flex-direction: column;

    .hc-title {
      color: #000000;
      font-weight: bold;
      font-size: 16px;
    }

    .hc-list {
      display: flex;
      flex-direction: column;

      .list-item {
        padding: 15px;
        margin-top: 20px;
        border: 2px solid #D7D7D7;
        border-radius: 8px;
        display: flex;
        flex-direction: row;
        align-items: center;

        &:hover {
          border: 2px solid #1464FF;
        }

        .el-image {
          width: 128px;
          height: 128px;
        }

        .info {
          flex: 1;
          width: 0;
          height: 90%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-left: 10px;

          .content {
            color: #2D2D2D;
            font-size: 14px;
            font-weight: bold;

            span {
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .c-icon-name {
              display: flex;
              flex-direction: row;
              align-items: center;

              .el-image {
                width: 40px;
                height: 40px;
                margin-right: 2px;
              }
            }
          }

          .time-btn {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;

            .time {
              color: #000000;
              font-size: 14px;
            }

            .btn-group {
              display: flex;
              flex-direction: row;
              align-items: center;

              .el-button {
                background-color: #1464FF;
              }
            }
          }
        }
      }
    }
  }
}
</style>